import {Controller} from "stimulus"

export default class extends Controller {

    static targets = []
    static windowName = "Something"

    initialize() {
        this.$button.addEventListener("click", e => this.share(e))
    }

    share(e){
        e.preventDefault()
        window.open(this.url, this.constructor.windowName, "toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,width=550,height=285,resizable=1")
    }

    get urlParameters(){
        const params = new URLSearchParams()
        params.append("url", this.data.get("url"))
        params.append("text", this.data.get("text"))
        return `?${params.toString()}`
    }

    get url(){
        console.log("url final", this.$button.getAttribute("href") + this.urlParameters)
        return this.$button.getAttribute("href") + this.urlParameters
    }

    get $button(){
        return this.element
    }


}